<template>
    <sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>
        <template slot="table-filter" v-if="isRegimeDomiciliare()">
            <b-row :key="key">
                <!--    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" style="margin-top: 5px"> -->
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                    <div v-if="accessoAdi.stato === 'APERTO'">
                        <b-button variant="danger" size="sm" @click="onClickSalvaAccesso('CHIUSO')"> <i class="fa fa-minus"></i> Chiudi Accesso </b-button>
                    </div>
                    <div v-else>
                        <b-button variant="success" size="sm" @click="onClickSalvaAccesso('APERTO')"> <i class="fa fa-plus"></i> Apri Nuovo Accesso </b-button>
                    </div>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <rsa-paziente-aree-component ref="cmpRsaAree" :utente="utente" @afterSaveAccessoAdi="onAfterSaveAccessoAdi"></rsa-paziente-aree-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteAreeComponent from "../../rsagestioneospiti/components/RsaPazienteAreeComponent.vue";
export default {
    props: {
        utente: { type: Object },
    },
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteAreeComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            idAccettazione: null,
            btnNuovaRichiestaEsameHidden: true,
            btnNuovaRichiestaUscita: true,
            filtro: {},
            btnNewVisible: true,
            pathResource: null,
            pathResourceAccettazione: "/accettazioni",
            linkedit: null,
            linkback: "/rsagestioneospiti",
            pathResourceAdiAccesso: "/rsaadiaccessi",
            showModalLoading: false,
            key: 0,
            accessoAdi: {},
            jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = this.$route.query.idAccettazione;
        me.loadAccettazione();
        me.loadAccesso();
    },
    watch: {},
    methods: {
        loadAccettazione() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.$refs.cmpRsaAree.init(me.jsonData /* , me.accessoAdi */);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        loadAccesso() {
            let me = this;
            me.loadDataResources(me.pathResourceAdiAccesso + "/aperto/" + me.idAccettazione, {}, me.resultResponseAdiAccesso, me.resultErrorAdiAccesso);
        },
        resultResponseAdiAccesso(response) {
            let me = this;
            me.accessoAdi = response.data.data;
            me.key++;
        },
        resultErrorAdiAccesso(error) {
            let me = this;
            if (error.response.status === 404) {
                me.accessoAdi = {};
            } else {
                this.$bvToast.toast("Erorre nel servizio per l'Accesso Adi", {
                    title: "Attenzione",
                    variant: "danger",
                    solid: true,
                });
            }
            me.key++;
        },
        isRegimeDomiciliare() {
            let me = this;
            return me.jsonData.statoAttuale === "ACCETTATO_ADI" || me.jsonData.statoAttuale === "ACCETTATO_HOSPICE";
        },
        onAfterSaveAccessoAdi() {
            let me = this;
            me.loadAccesso();
        },
        onClickSalvaAccesso(stato) {
            let me = this;
            me.$refs.cmpRsaAree.salvaAccessoAdi(stato);
        },
    },
};
</script>

<style></style>
